import Logo from "../../../../public/images/logo_30_30.svg";

const Block_Logo = () => (
    <div>
        <Logo />
    </div>
);

export default Block_Logo;
